import { DataBean } from "../../DataBean";


export class MeansAdministration extends DataBean {

    public async getMeansAdministrationCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getMeansAdministrationCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}